/** 租户标签管理 /metering/tenant/label-manage（labelManage/index.vue） */
export default {
  labelManagePage: {
    phKeyword: '标签名称',
    btnSearch: '查询',
    btnReset: '重置',
    btnRefresh: '刷新',
    sectionTitle: '标签管理',
    btnAddLabel: '新增标签',
    sortDefault: '默认排序',
    colId: 'ID',
    colName: '标签名称',
    colCreateTime: '创建时间',
    colUpdateTime: '更新时间',
    colAction: '操作',
    btnEdit: '编辑',
    btnBatchBind: '批量绑定',
    btnDelete: '删除',
    emptyNoData: '暂无数据',
    emptyNoPermission: '暂无查看权限',
    dialogEdit: '编辑标签',
    dialogAdd: '新增标签',
    formLabelName: '标签名称',
    phNameInput: '请输入标签名称',
    btnCancel: '取消',
    btnConfirm: '确定',
    dialogBindTitle: '批量绑定租户',
    phTenantSearch: '租户名称/编号',
    bindCurrentLabel: '当前标签：',
    btnSelectAll: '全选',
    btnClear: '清空',
    colTenantId: '租户ID',
    colTenantName: '租户名称',
    btnConfirmBind: '确定绑定',
    ruleNameRequired: '请输入标签名称',
    msgQueryFail: '查询失败',
    msgNoAddPerm: '暂无新增权限',
    msgNoEditPerm: '暂无编辑权限',
    msgNoDeletePerm: '暂无删除权限',
    msgSaveOk: '操作成功',
    msgSaveFail: '操作失败',
    titleTip: '提示',
    confirmDelete: '确认删除标签「{name}」吗？',
    msgDeleteOk: '删除成功',
    msgDeleteFail: '删除失败',
    msgBindSelectTenant: '请选择要绑定的租户',
    msgBindOk: '绑定成功',
    msgBindFail: '绑定失败',
    msgTenantQueryFail: '查询租户失败'
  }
}
